import useAuth from "@/hooks/auth";
import { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { paths } from "../paths";
import { useAppDispatch } from "@/store";
import { getProfileThunk } from "@/store/slices/auth/slice";
import Sidebar from "@/components/partials/sidebar";

const DashboardContext = createContext<{
  isSidebarOpen?: boolean;
  toggleSidebar: () => void;
}>({
  isSidebarOpen: false,
  toggleSidebar: () => {},
});

export const useDashboard = () => useContext(DashboardContext);

export default function PrivateRoutes() {
  const location = useLocation();

  const [isSidebar, setIsSidebar] = useState(false);
  const handleToggleSidebar = () => setIsSidebar((prev) => !prev);

  useEffect(() => {
    setIsSidebar(false);
  }, [location.pathname]);

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getProfileThunk());
  }, []);

  const [initState, setInitState] = useState(false);

  const navigate = useNavigate();

  const { accessToken } = useAuth();
  useEffect(() => {
    if (!accessToken) {
      return navigate(paths.login.index);
    }
    setInitState(true);
  }, [accessToken, navigate]);

  if (initState === false) return null;

  return (
    <DashboardContext.Provider
      value={{ isSidebarOpen: isSidebar, toggleSidebar: handleToggleSidebar }}
    >
      <div className='flex'>
        <Sidebar />
        <div className='w-full'>
          <main className='px-2 py-4 md:py-6 md:px-6 bg-gray-50 min-h-screen'>
            <Outlet />
          </main>
        </div>
      </div>
    </DashboardContext.Provider>
  );
}
